import { Theme, Tray } from '@busybusy/webapp-react-ui';
import { DeleteIcon, PrintIcon } from 'assets/icons';
import { ActionBar, IconButton } from 'components';
import { t } from 'i18next';

export interface ICertificationStatusActionBarProps {
  onDelete: () => void;
  onPrint: () => void;
  onClear: () => void;
  checkedIds: string[];
}

const CertificationStatusActionBar = (props: ICertificationStatusActionBarProps) => {
  const { onDelete, onPrint, onClear, checkedIds } = props;

  return (
    <>
      <ActionBar selectedCount={checkedIds.length} onClear={onClear}>
        <Tray spacing={1}>
          <IconButton svg={PrintIcon} onClick={onPrint} tooltipLabel={t('Print')} theme={Theme.DARK} />
          <IconButton svg={DeleteIcon} onClick={onDelete} tooltipLabel={t('Delete')} theme={Theme.DARK} />
        </Tray>
      </ActionBar>
    </>
  );
};

export default CertificationStatusActionBar;
